import * as React from "react";
const SvgArrowRight = props => <svg width={16} height={15} viewBox="0 0 16 15" xmlns="http://www.w3.org/2000/svg" {...props}><path d="M8.5 1.5L14.5 7.5L8.5 13.5M13.6667 7.5L1.5 7.5" fill="none" stroke="currentColor" /></svg>;
export default SvgArrowRight;